export default function configureLocalStorage(app: any) {
  app.config([
    'localStorageServiceProvider',
    function (localStorageServiceProvider: any) {
      localStorageServiceProvider.setStorageType('localStorage');
    }
  ]);
}
